import logo from "../assets/images/logo.png";
import hero from "../assets/images/hero.jpg";
import map from "../assets/images/map.png";

export const ASSETS = {
  logo,
  hero,
  map,
};

// Bilingual content (PL primary, EN secondary)
export const translations = {
  pl: {
    nav: {
      about: "O nas",
      services: "Zakres",
      map: "Gdzie działamy",
      trainings: "Szkolenia PTV",
      contact: "Kontakt",
      langLabel: "Język",
    },
    hero: {
      eyebrow: "FORECASTFLOW · Transport · Modelowanie · Prognozy",
      motto: "Planowanie zaczyna się tu.",
      sub: "Kompleksowe opracowania transportowe, modele i prognozy ruchu, mikrosymulacje oraz doradztwo.",
      cta: "Skontaktuj się",
      ctaSecondary: "Zobacz zakres",
      scroll: "Przewiń",
    },
    stats: [
      { value: "6", label: "Krajów doświadczenia w terenie" },
      { value: "28", label: "Obszarów analiz w Polsce" },
      { value: "60+", label: "Szkoleń zrealizowanych od 2019" },
      { value: "102,240", label: "Wyliczonych przebiegów random seed" },
    ],
    about: {
      label: "01 — O nas",
      title: "Inżynieria, która porusza.",
      body: [
        "Specjalizujemy się w kompleksowych opracowaniach transportowych — zarówno planach i projektach transportowych, prognozach ruchu i lokalnych case study z branż drogowych, w tym analizach parkingowych, oraz kolejowych, również z analizą pieszą dworców i węzłów przesiadkowych.",
        "Założycielem i głównym specjalistą jest Krystian Siwek - analityk transportowy z wieloletnim doświadczeniem krajowym i międzynarodowym. Zespół współtworzą specjaliści z szerokim portfolio realizacji dla najważniejszych podmiotów krajowych i głównych ośrodków miejskich, jak również jako autorzy opracowń zagranicznych.",
        "Nasz zespół aktywnie uczestniczy w organizacji warsztatów i szkoleń dla przedstawicieli branż drogowych, kolejowych, organizatorów transportu publicznego oraz biur projektowych, dzieląc się wiedzą i praktycznym doświadczeniem. Jesteśmy certyfikowanymi szkoleniowcami w zakresie wykorzystywanego na polskim rynku oprogramowania do prognoz ruchu.",
        "Dbamy o najwyższy standard opracowań korzystając z najnowszych technologii i doświadczeń rynkowych, by nasze opracowania spełniały potrzeby miast, regionów oraz inwestycji.",
      ],
    },
    services: {
      label: "02 — Zakres działalności",
      title: "Sześć obszarów. Jeden standard.",
      items: [
        {
          code: "01",
          title: "Analizy ruchu",
          desc: "Opracowujemy analizy ruchu dla planowanych i modernizowanych inwestycji infrastrukturalnych. Badamy wpływ powstania nowych obiektów (m.in. osiedli, zakładów pracy, obiektów wielkopowierzchniowych) na lokalny i regionalny układ drogowy.",
        },
        {
          code: "02",
          title: "Modele i prognozy ruchu",
          desc: "Tworzymy międzygałęziowe modele oraz prognozy ruchu w skali strategicznej stanowiące część opracowań transportowych, analiz komunikacyjnych i studiów infrastrukturalnych. Nasze działania obejmują zarówno mniejsze miasta, jak i projekty o znaczeniu ogólnokrajowym.",
        },
        {
          code: "03",
          title: "Mikrosymulacja",
          desc: "Przygotowujemy mikrosymulacje ruchu drogowego, parkingów, transportu publicznego oraz ruchu pieszego. Posiadamy doświadczenie w opiniowaniu opracowań mikrosymulacyjnych oraz współtworzeniu wytycznych dla sektora publicznego.",
        },
        {
          code: "04",
          title: "Koncepcje transportowe oraz doradztwo",
          desc: "Oferujemy kompleksowe usługi w zakresie tyczenia szlaków komunikacyjnych, przygotowania planów remarszrutyzacji linii oraz doradztwa w zakresie nowoczesnej i zrównoważonej mobilności.",
        },
        {
          code: "05",
          title: "Sterowanie ruchem i analiza przepustowości",
          desc: "Przygotowujemy projekty sterowania ruchem wraz z opracowaniem dokumentacji, logiki sterowania oraz weryfikacją działania sterownika w środowisku mikrosymulacyjnym. Wykonujemy analizy przepustowości ruchu drogowego.",
        },
        {
          code: "06",
          title: "Pomiary ruchu i organizacja ruchu",
          desc: "Prowadzimy 24-godzinne pomiary ruchu drogowego. Przygotowujemy czasowe oraz stałe organizacje ruchu, posiadamy aktualny certyfikat audytora BRD.",
        },
      ],
    },
    map: {
      label: "03 — Gdzie działamy",
      title: "Gdzie działamy.",
      subtitle:
        "Realizujemy projekty na terenie całej Polski - w miastach każej wielkości, opracowania regionalne i punktowe analizy studyjne. Powiększamy też nasze doświadczenia międzynarodowe.",
      caption: "Gdzie działamy / Our actions",
    },
    ptv: {
      label: "04 — Szkolenia PTV",
      badge: "Certified PTV Trainer",
      title: "Szkolenia PTV — Visum, Vissim, Viswalk.",
      body: "Jesteśmy certyfikowanymi szkoleniowcami PTV z wieloletnim doświadczeniem na rynku polskim i europejskim w zakresie prognoz strategicznych (PTV Visum), symulacji (Vissim) i analiz pieszych (Viswalk). Przygotowujemy indywidualne szkolenia w zależności od potrzeb użytkowników, zarówno dla sektora publicznego jak i prywatnego. Od 2019 roku zrealizowaliśmy ponad 60 szkoleń, w tym dla najważniejszych instytucji w kraju i Europie.",
      tools: [
        {
          name: "PTV Visum",
          desc: "Prognozy strategiczne, plany transportowe, rozwój i optymalizacja systemów transportowych, wsparcie miast i regionów.",
        },
        {
          name: "PTV Vissim",
          desc: "Mikrosymulacja, analizy drogowe, parkingowe, przebudowa i rozbudowa infrastruktury, optymalizacja ruchu.",
        },
        {
          name: "PTV Viswalk",
          desc: "Analizy piesze, dworce, węzły przesiadkowe, terminale lotniskowe, obiekty wielkopowierzchniowe, symulacje ewakuacji.",
        },
      ],
    },
    contact: {
      label: "05 — Kontakt",
      title: "Porozmawiajmy o Twoim projekcie.",
      sub: "Napisz lub zadzwoń do nas.",
      emailLabel: "E-mail",
      phoneLabel: "Telefon",
      linkedinLabel: "LinkedIn",
    },
    footer: {
      rights: "Wszelkie prawa zastrzeżone.",
      tagline: "Planowanie zaczyna się tu.",
    },
  },
  en: {
    nav: {
      about: "About",
      services: "Scope",
      map: "Where we act",
      trainings: "PTV Trainings",
      contact: "Contact",
      langLabel: "Language",
    },
    hero: {
      eyebrow: "FORECASTFLOW · Transport · Modelling · Forecasting",
      motto: "Engineering starts here.",
      sub: "Comprehensive transportation studies, traffic models and forecasts, microsimulation and advisory.",
      cta: "Get in touch",
      ctaSecondary: "View scope",
      scroll: "Scroll",
    },
    stats: [
      { value: "6", label: "Countries of field experience" },
      { value: "28", label: "Completed study locations in Poland" },
      { value: "60+", label: "Trainings delivered since 2019" },
      { value: "102,240", label: "Random-seed runs calculated" },
    ],
    about: {
      label: "01 — About",
      title: "Engineering that orchestrates movement.",
      body: [
        "We specialize in comprehensive transportation studies — including both transport plans and projects, traffic forecasts, and local case studies from the road sector, including parking analyses, as well as the railway sector, including pedestrian analyses of stations and interchange nodes.",
        "Founded by Krystian Siwek, an experienced specialist with a strong track record of local and international projects, our team brings together experts with extensive experience delivering projects for key national organizations and major cities.",
        "Our team actively participates in organizing workshops and training courses for representatives of the road and railway sectors, public transport authorities, and design consultancies, sharing knowledge and practical experience. We are certified trainers for the traffic forecasting software utilized in the Polish market.",
        "We ensure the highest standard of studies by using the latest technologies and market practices to ensure our deliverables meet the needs of cities, regions, and investments.",
      ],
    },
    services: {
      label: "02 — Scope of activity",
      title: "Six disciplines. One standard.",
      items: [
        {
          code: "01",
          title: "Traffic Analyses",
          desc: "We conduct traffic impact assessments and analyses for proposed and modernized infrastructure developments. We evaluate the impact of new investments (residential estates, industrial plants, commercial facilities) on local and regional road systems.",
        },
        {
          code: "02",
          title: "Traffic Modeling & Forecasting",
          desc: "We develop multimodal traffic models and macro-level forecasts as part of comprehensive transportation studies, traffic analyses, and infrastructure feasibility reports. Our portfolio spans from small municipalities to initiatives of national significance.",
        },
        {
          code: "03",
          title: "Microsimulation",
          desc: "We deliver high-fidelity traffic microsimulations for vehicular traffic, parking simulation, public transit, and pedestrian movement. Our expertise includes peer-reviewing third-party models and co-authoring technical guidelines for the public sector.",
        },
        {
          code: "04",
          title: "Transportation Concepts & Advisory",
          desc: "End-to-end consulting in alignment optimization, transit network redesign (rerouting), and strategic advisory for modern, sustainable urban mobility.",
        },
        {
          code: "05",
          title: "Traffic Control & Capacity Analysis",
          desc: "We design traffic signal control systems, including engineering documentation, signal control logic, and controller verification within microsimulation environments. We also perform rigorous roadway and intersection capacity analyses.",
        },
        {
          code: "06",
          title: "Traffic Surveys & Management",
          desc: "We conduct comprehensive 24-hour traffic volume counts and data collection. We design temporary and permanent traffic management plans (TMPs), backed by certified Road Safety Audit (RSA) credentials.",
        },
      ],
    },
    map: {
      label: "03 — Where we act",
      title: "Where we act",
      subtitle:
        "We operate across entire Poland delivering city projects, regional assessments and local studies. We have extensive international experience in specific European areas.",
      caption: "Gdzie działamy / Our actions",
    },
    ptv: {
      label: "04 — PTV Trainings",
      badge: "Certified PTV Trainer",
      title: "PTV Trainings — Visum, Vissim, Viswalk.",
      body: "We are certified PTV trainers with extensive, long-standing experience in the Polish and European markets, specializing in strategic macro-level forecasting (PTV Visum), microsimulation (PTV Vissim), and pedestrian analysis (PTV Viswalk). We design bespoke training programs to meet the specific requirements of our clients across the public and private sectors. Since 2019, we have successfully delivered over 60 training courses, including sessions for premier transport authorities and institutions both nationally and across Europe.",
      tools: [
        {
          name: "PTV Visum",
          desc: "Strategic forecasts, transport plans, development and optimization of transport systems, support for cities and regions.",
        },
        {
          name: "PTV Vissim",
          desc: "Microsimulation, road and parking analyses, reconstruction and expansion of infrastructure, traffic optimization.",
        },
        {
          name: "PTV Viswalk",
          desc: "Pedestrian analyses, stations, interchange hubs, airport terminals, large-scale facilities, evacuation simulations.",
        },
      ],
    },
    contact: {
      label: "05 — Contact",
      title: "Let's talk about your project.",
      sub: "Call or write to us.",
      emailLabel: "Email",
      phoneLabel: "Phone",
      linkedinLabel: "LinkedIn",
    },
    footer: {
      rights: "All rights reserved.",
      tagline: "Engineering starts here.",
    },
  },
};

export const CONTACT = {
  email: "kontakt@forecastflow.pl",
  phone: "+48 889 486 359",
  linkedin: "https://www.linkedin.com/company/forecastflowpl/",
};
